export const translations = {
  ko: {
    // Navigation
    nav: {
      vision: '비전',
      services: '서비스',
      journey: '여정',
      contact: '함께하기',
      secondTeam: '세컨팀',
      careerly: '커리어리'
    },

    // Hero Section
    hero: {
      subtitle: '기술과 사람 사이,',
      title1: "우리는 미래 세대의 '일'을",
      title2: '다시 설계합니다',
      description: 'AI 시대의 커리어 인프라를 만드는 팀,',
      company: 'seeso',
      cta: '우리의 비전 보기'
    },

    // Vision Section
    vision: {
      title: '우리가 만드는 미래',
      question1: '우리는 하나의 질문에서 출발했습니다.',
      question2: "'일'은 앞으로 어떻게 변할 것인가?",
      description1: '시소는 미래 세대의',
      description1Bold: '일과 노동의 본질',
      description2: '에 대해 고민하는 팀입니다.',
      description3: '우리는 외주, 협업, 채용, 교육, 성장 전반에 걸쳐',
      description4: 'AI와 데이터를 기반으로',
      description4Bold: '커리어의 새로운 인프라',
      description5: '를 만들고 있습니다.'
    },

    // Services Section
    services: {
      title: '두 개의 축',
      subtitle: '- seeso의 실험',

      // Second Team
      secondTeam: {
        title: '세컨팀',
        subtitle: '- 아웃소싱의 미래',
        intro1: '과거 우리는 사람을 연결해 일했습니다.',
        intro2: '이제는',
        intro2Bold: 'AI 도구와 사람을 연결해 일합니다.',
        description1: '세컨팀은 GPT, Claude, Jules 등의 도구를 활용해',
        description2: '기획/디자인/개발의 경계를 허문 새로운 아웃소싱을 실험합니다.',
        description3: '누구나 바이브코딩을 통해',
        description4: '10배 빠르게 실험하고, 실패하고, 성공할 수 있는 구조',
        description5: '를 제공합니다.',
        highlight1: '→ 우리는 더 이상 \'외주\'라고 부르지 않습니다.',
        highlight2: '이것은',
        highlight2Bold: '새로운 일의 방식',
        highlight3: '입니다.',
        cta: '세컨팀 더 알아보기'
      },

      // Careerly
      careerly: {
        title: '커리어리',
        subtitle: '- 커리어의 OS + AI 레이어',
        intro1: '커리어리는 단순한 이직 플랫폼이 아닙니다.',
        intro2: '우리는 "이력서 이후의 커리어"를 설계합니다.',
        point1: '내가 해온 모든 \'일의 흔적\'을 데이터로 만들고',
        point2: 'AI가 나보다 나를 더 잘 아는 커리어 코치가 되어',
        point3: '나에게 필요한 연결, 추천, 전략을 제안합니다',
        highlight1: '이제 커리어는 정리된 요약이 아니라,',
        highlight2: '살아 있는 로그와 가능성의 지도',
        highlight3: '가 됩니다.',
        cta: '커리어리 바로가기'
      }
    },

    // Connection Vision
    connection: {
      title: '우리가 꿈꾸는 미래',
      subtitle: '두 가지 혁신이 만드는 하나의 세상',
      description1: '세컨팀은 AI로 일하는 방법을 변화시키고,',
      description2: '커리어리는 AI로 성장하는 방법을 혁신합니다.',
      description3: '이 두 서비스는 결국 하나의 비전으로 통합됩니다.',
      description4: '모든 사람이 AI와 함께 자신만의 커리어를 창조하는 세상.',

      promises: {
        title: '우리의 약속',
        promise1Title: '모든 일이 경험이 되는 세상',
        promise1Desc: '프로젝트, 협업, 학습 - 모든 과정이 당신의 성장 자산이 됩니다.',
        promise2Title: 'AI가 당신의 커리어 파트너',
        promise2Desc: '당신보다 당신을 더 잘 이해하는 AI가 최적의 기회를 제안합니다.',
        promise3Title: '일과 성장의 새로운 표준',
        promise3Desc: '우리는 커리어 인프라를 통해 일의 미래를 재정의합니다.'
      }
    },

    // Journey Section
    journey: {
      title: '걸어온 길',
      subtitle: '- 우리의 기록',
      description1: '시소는 단순한 스타트업이 아닙니다.',
      description2: '우리는 수년간 IT 협업, 외주, 커뮤니티, 플랫폼, 데이터, 커리어를 연결해 왔습니다.',

      period1: {
        year: '2016 ~ 2020',
        title: '첫 발걸음',
        description: '"좋은 아이디어가 있지만 IT 개발이 어려운 스타트업을 위해"라는 모토로 시작했습니다. 1,000개가 넘는 프로젝트를 성공적으로 수행하며, 신뢰할 수 있는 IT 협업의 새로운 기준을 만들었습니다. 원격 근무와 부업 가능한 인재풀 모델은 현재 IT 업계의 표준이 되었습니다.',
        tags: ['법인 설립', 'TIPS 선정', '1,000개 스프린트']
      },

      period2: {
        year: '2021 ~ 2023',
        title: '플랫폼 전환의 실험',
        description: '"단순한 외주가 아닌, 일하는 방식의 혁신"을 꿈꾸며 세컨팀을 론칭했습니다. 프로젝트 매칭 플랫폼을 통해 기업과 인재를 연결하고, AI 시대를 준비하며 일의 데이터화와 자동화를 실험하기 시작했습니다.',
        tags: ['세컨팀 론칭', '제주창조경제혁신센터 최우수상', 'AI 서비스 실험']
      },

      period3: {
        year: '2024 ~ 2025',
        title: '커리어 인프라 기업으로 도약',
        description: '30만 명의 커리어 커뮤니티 \'커리어리\'를 인수하며 새로운 도약을 시작했습니다. AI 커리어 에이전트를 개발하고, 글로벌 프로그램을 론칭하며, "일과 성장의 인프라"를 구축하는 커리어 인프라 기업으로 진화했습니다.',
        tags: ['커리어리 인수', 'AI 커리어 에이전트', '바이브코딩 세컨팀 리뉴얼']
      }
    },

    // Join Us Section
    joinUs: {
      title: '함께 만들어갈 파트너',
      description: '시소와 함께 AI 시대의 새로운 일의 문화를 만들어갈 파트너를 찾습니다',

      roles: {
        developer: {
          title: 'AI 개발자',
          description: 'AI 도구와 함께 새로운\n개발 문화를 만들어갈 분들'
        },
        startup: {
          title: '스타트업 & 크리에이터',
          description: '아이디어를 빠르게 현실로\n만들고 싶은 창업가와 창작자'
        },
        partnership: {
          title: '파트너십',
          description: '함께 혁신적인 프로젝트를\n만들어갈 기업 파트너'
        },
        investor: {
          title: '투자자',
          description: '커리어 인프라의 미래를\n함께 만들어갈 투자 파트너'
        }
      },

      cta: 'partner@seeso.kr로 연락하기'
    },

    // Footer
    footer: {
      tagline: 'We are building the operating system for work and growth in the AI era.',
      company: '(주)시소 (대표이사: 박병규)',
      address1: '제주특별자치도 제주시 중앙로217 제주벤처마루 3층 & 서울특별시 성동구 성수일로3길 5-12, 2층',
      businessNumber: '통신판매업신고번호: 2018-서울강남-04590 | 사업자등록번호: 171-88-00464',
      privacy: '개인정보보호관리자: 박병규',
      copyright: 'Copyright © seeso Inc.'
    }
  },

  en: {
    // Navigation
    nav: {
      vision: 'Vision',
      services: 'Services',
      journey: 'Journey',
      contact: 'Join Us',
      secondTeam: 'Second Team',
      careerly: 'Careerly'
    },

    // Hero Section
    hero: {
      subtitle: 'Between technology and people,',
      title1: "We are redesigning the future of 'work'",
      title2: 'for the next generation',
      description: 'Building career infrastructure for the AI era,',
      company: 'seeso',
      cta: 'Explore Our Vision'
    },

    // Vision Section
    vision: {
      title: 'The Future We\'re Building',
      question1: 'We started with one question.',
      question2: "How will 'work' evolve in the future?",
      description1: 'SEESO contemplates the',
      description1Bold: 'essence of work and labor',
      description2: 'for future generations.',
      description3: 'We are building',
      description4: 'a new infrastructure for careers',
      description4Bold: 'new career infrastructure',
      description5: 'based on AI and data, spanning outsourcing, collaboration, recruitment, education, and growth.'
    },

    // Services Section
    services: {
      title: 'Two Pillars',
      subtitle: '- SEESO\'s Experiment',

      // Second Team
      secondTeam: {
        title: 'Second Team',
        subtitle: '- The Future of Outsourcing',
        intro1: 'In the past, we connected people to work.',
        intro2: 'Now,',
        intro2Bold: 'we connect AI tools and people to work.',
        description1: 'Second Team leverages tools like GPT, Claude, and Jules',
        description2: 'to experiment with new outsourcing that breaks down the boundaries between planning, design, and development.',
        description3: 'We provide a structure where anyone can',
        description4: 'experiment, fail, and succeed 10x faster',
        description5: 'through vibe coding.',
        highlight1: '→ We no longer call it \'outsourcing\'.',
        highlight2: 'This is',
        highlight2Bold: 'a new way of working',
        highlight3: '.',
        cta: 'Learn More About Second Team'
      },

      // Careerly
      careerly: {
        title: 'Careerly',
        subtitle: '- Career OS + AI Layer',
        intro1: 'Careerly is not just a job-switching platform.',
        intro2: 'We design "careers beyond resumes."',
        point1: 'Turn all your \'work traces\' into data',
        point2: 'AI becomes a career coach that knows you better than yourself',
        point3: 'Suggests connections, recommendations, and strategies you need',
        highlight1: 'Now, a career is not a polished summary,',
        highlight2: 'but a living log and map of possibilities',
        highlight3: '.',
        cta: 'Go to Careerly'
      }
    },

    // Connection Vision
    connection: {
      title: 'The Future We Dream Of',
      subtitle: 'One World Created by Two Innovations',
      description1: 'Second Team transforms how we work with AI,',
      description2: 'and Careerly innovates how we grow with AI.',
      description3: 'These two services ultimately merge into one vision.',
      description4: 'A world where everyone creates their own career with AI.',

      promises: {
        title: 'Our Promise',
        promise1Title: 'A world where all work becomes experience',
        promise1Desc: 'Projects, collaboration, learning - every process becomes your growth asset.',
        promise2Title: 'AI as your career partner',
        promise2Desc: 'AI that understands you better than yourself suggests optimal opportunities.',
        promise3Title: 'New standards for work and growth',
        promise3Desc: 'We redefine the future of work through career infrastructure.'
      }
    },

    // Journey Section
    journey: {
      title: 'Our Journey',
      subtitle: '- Our Story',
      description1: 'SEESO is not just a startup.',
      description2: 'We have been connecting IT collaboration, outsourcing, communities, platforms, data, and careers for years.',

      period1: {
        year: '2016 ~ 2020',
        title: 'First Steps',
        description: 'We started with the motto "For startups with great ideas but difficult IT development." Successfully completing over 1,000 projects, we established a new standard for reliable IT collaboration. Our remote work and side-job talent pool model has become the standard in the IT industry.',
        tags: ['Company Established', 'TIPS Selected', '1,000 Sprints']
      },

      period2: {
        year: '2021 ~ 2023',
        title: 'Platform Transformation Experiment',
        description: 'We launched Second Team, dreaming of "innovation in working methods, not just outsourcing." We connected companies and talent through a project matching platform and began experimenting with the datafication and automation of work in preparation for the AI era.',
        tags: ['Second Team Launch', 'Jeju Creative Economy Innovation Center Grand Prize', 'AI Service Experiment']
      },

      period3: {
        year: '2024 ~ 2025',
        title: 'Leap to Career Infrastructure Company',
        description: 'We started a new leap by acquiring \'Careerly\', a career community of 300,000 people. We developed an AI career agent, launched global programs, and evolved into a career infrastructure company building "infrastructure for work and growth."',
        tags: ['Careerly Acquisition', 'AI Career Agent', 'Vibe Coding Second Team Renewal']
      }
    },

    // Join Us Section
    joinUs: {
      title: 'Partners to Build Together',
      description: 'We are looking for partners to create a new work culture for the AI era with SEESO',

      roles: {
        developer: {
          title: 'AI Developers',
          description: 'Those who will create a new\ndevelopment culture with AI tools'
        },
        startup: {
          title: 'Startups & Creators',
          description: 'Entrepreneurs and creators who want to\nturn ideas into reality quickly'
        },
        partnership: {
          title: 'Partnership',
          description: 'Corporate partners to create\ninnovative projects together'
        },
        investor: {
          title: 'Investors',
          description: 'Investment partners to build\nthe future of career infrastructure'
        }
      },

      cta: 'Contact us at partner@seeso.kr'
    },

    // Footer
    footer: {
      tagline: 'We are building the operating system for work and growth in the AI era.',
      company: 'SEESO Inc. (CEO: Byungkyu Park)',
      address1: '3F Jeju Venture Maru, 217 Jungang-ro, Jeju-si, Jeju Special Self-Governing Province & 2F, 5-12 Seongsuil-ro 3-gil, Seongdong-gu, Seoul',
      businessNumber: 'E-commerce Registration: 2018-Seoul Gangnam-04590 | Business Registration: 171-88-00464',
      privacy: 'Privacy Manager: Byungkyu Park',
      copyright: 'Copyright © seeso Inc.'
    }
  },

  ja: {
    // Navigation
    nav: {
      vision: 'ビジョン',
      services: 'サービス',
      journey: '歩み',
      contact: '参加する',
      secondTeam: 'セカンドチーム',
      careerly: 'キャリアリー'
    },

    // Hero Section
    hero: {
      subtitle: '技術と人の間で、',
      title1: "私たちは次世代の「仕事」を",
      title2: '再設計します',
      description: 'AI時代のキャリアインフラを創る、',
      company: 'seeso',
      cta: '私たちのビジョンを見る'
    },

    // Vision Section
    vision: {
      title: '私たちが創る未来',
      question1: '私たちは一つの質問から始まりました。',
      question2: "「仕事」はこれからどう変わるのか？",
      description1: 'SEESOは次世代の',
      description1Bold: '仕事と労働の本質',
      description2: 'について考えるチームです。',
      description3: '私たちはアウトソーシング、協業、採用、教育、成長全般にわたり、',
      description4: 'AIとデータに基づいた',
      description4Bold: 'キャリアの新しいインフラ',
      description5: 'を構築しています。'
    },

    // Services Section
    services: {
      title: '2つの軸',
      subtitle: '- SEESOの実験',

      // Second Team
      secondTeam: {
        title: 'セカンドチーム',
        subtitle: '- アウトソーシングの未来',
        intro1: '過去、私たちは人と人を繋いで仕事をしました。',
        intro2: '今は、',
        intro2Bold: 'AIツールと人を繋いで仕事をします。',
        description1: 'セカンドチームはGPT、Claude、Julesなどのツールを活用し、',
        description2: '企画・デザイン・開発の境界を取り払った新しいアウトソーシングを実験しています。',
        description3: '誰でもバイブコーディングを通じて、',
        description4: '10倍速く実験し、失敗し、成功できる構造',
        description5: 'を提供します。',
        highlight1: '→ 私たちはもう「外注」とは呼びません。',
        highlight2: 'これは',
        highlight2Bold: '新しい働き方',
        highlight3: 'です。',
        cta: 'セカンドチームをもっと知る'
      },

      // Careerly
      careerly: {
        title: 'キャリアリー',
        subtitle: '- キャリアのOS + AIレイヤー',
        intro1: 'キャリアリーは単なる転職プラットフォームではありません。',
        intro2: '私たちは「履歴書以降のキャリア」を設計します。',
        point1: '自分がしてきた全ての「仕事の痕跡」をデータ化し、',
        point2: 'AIが自分より自分をよく知るキャリアコーチになり、',
        point3: '必要な繋がり、推薦、戦略を提案します',
        highlight1: 'これからキャリアは整理された要約ではなく、',
        highlight2: '生きているログと可能性の地図',
        highlight3: 'になります。',
        cta: 'キャリアリーへ行く'
      }
    },

    // Connection Vision
    connection: {
      title: '私たちが夢見る未来',
      subtitle: '2つのイノベーションが創る1つの世界',
      description1: 'セカンドチームはAIで働く方法を変え、',
      description2: 'キャリアリーはAIで成長する方法を革新します。',
      description3: 'この2つのサービスは最終的に1つのビジョンに統合されます。',
      description4: '全ての人がAIと共に自分だけのキャリアを創造する世界。',

      promises: {
        title: '私たちの約束',
        promise1Title: '全ての仕事が経験になる世界',
        promise1Desc: 'プロジェクト、協業、学習 - 全てのプロセスがあなたの成長資産になります。',
        promise2Title: 'AIがあなたのキャリアパートナー',
        promise2Desc: 'あなたよりあなたをよく理解するAIが最適な機会を提案します。',
        promise3Title: '仕事と成長の新しい基準',
        promise3Desc: '私たちはキャリアインフラを通じて仕事の未来を再定義します。'
      }
    },

    // Journey Section
    journey: {
      title: '歩んできた道',
      subtitle: '- 私たちの記録',
      description1: 'SEESOは単なるスタートアップではありません。',
      description2: '私たちは長年、IT協業、アウトソーシング、コミュニティ、プラットフォーム、データ、キャリアを繋いできました。',

      period1: {
        year: '2016 ~ 2020',
        title: '最初の一歩',
        description: '「良いアイデアはあるがIT開発が難しいスタートアップのために」というモットーで始まりました。1,000を超えるプロジェクトを成功裏に遂行し、信頼できるIT協業の新しい基準を作りました。リモートワークと副業可能な人材プールモデルは現在のIT業界の標準となりました。',
        tags: ['法人設立', 'TIPS選定', '1,000スプリント']
      },

      period2: {
        year: '2021 ~ 2023',
        title: 'プラットフォーム転換の実験',
        description: '「単純な外注ではなく、働き方の革新」を夢見てセカンドチームをローンチしました。プロジェクトマッチングプラットフォームを通じて企業と人材を繋ぎ、AI時代に備えて仕事のデータ化と自動化の実験を始めました。',
        tags: ['セカンドチームローンチ', '済州創造経済革新センター最優秀賞', 'AIサービス実験']
      },

      period3: {
        year: '2024 ~ 2025',
        title: 'キャリアインフラ企業へ飛躍',
        description: '30万人のキャリアコミュニティ「キャリアリー」を買収し、新たな飛躍を始めました。AIキャリアエージェントを開発し、グローバルプログラムをローンチし、「仕事と成長のインフラ」を構築するキャリアインフラ企業へと進化しました。',
        tags: ['キャリアリー買収', 'AIキャリアエージェント', 'バイブコーディングセカンドチームリニューアル']
      }
    },

    // Join Us Section
    joinUs: {
      title: '共に創るパートナー',
      description: 'SEESOと共にAI時代の新しい仕事の文化を創るパートナーを探しています',

      roles: {
        developer: {
          title: 'AI開発者',
          description: 'AIツールと共に新しい\n開発文化を創る方々'
        },
        startup: {
          title: 'スタートアップ & クリエイター',
          description: 'アイデアを素早く現実に\nしたい起業家とクリエイター'
        },
        partnership: {
          title: 'パートナーシップ',
          description: '革新的なプロジェクトを\n共に創る企業パートナー'
        },
        investor: {
          title: '投資家',
          description: 'キャリアインフラの未来を\n共に創る投資パートナー'
        }
      },

      cta: 'partner@seeso.krへ連絡する'
    },

    // Footer
    footer: {
      tagline: 'We are building the operating system for work and growth in the AI era.',
      company: '株式会社SEESO（代表取締役：パク・ビョンギュ）',
      address1: '済州特別自治道済州市中央路217 済州ベンチャーマル3階 & ソウル特別市城東区城水一路3ギル5-12、2階',
      businessNumber: '通信販売業申告番号: 2018-ソウル江南-04590 | 事業者登録番号: 171-88-00464',
      privacy: '個人情報保護管理者: パク・ビョンギュ',
      copyright: 'Copyright © seeso Inc.'
    }
  }
};
